import './FellowshipTracker.css'

import { useState, useEffect, useMemo, useCallback } from 'react';
import Navbar from '../components/Navbar'
import hobbitLora from '../assets/images/hobbitlora.gif';

import MileageDisplay from '../components/MileageDisplay'
import FellowshipEggCorner from '../components/FellowshipEggCorner'
import FellowshipUnseenEggReveal, {
  buildUnseenEggBatches,
} from '../components/FellowshipUnseenEggReveal'
import FellowshipUnseenPoopReveal from '../components/FellowshipUnseenPoopReveal'
import { URL, ALL_LOCATIONS, IMAGE_MAP } from '../components/constants'

function Track({ people, locations }) {
  const TOTAL_MILEAGE = 1780;

  const leftPct = (miles) =>
    Math.min((miles / TOTAL_MILEAGE) * 100, 100);

  return (
    <div className="track">

      {/* Tick marks + labels */}
      {locations.map((location) => {
        return (
          <div
            key={`tick-${location.name}`}
            className="track-tick"
            style={{ left: `${leftPct(location.miles)}%` }}
          >
            <div className="tick-line" />
            <div className="tick-label" title={location.miles + " miles"}>{location.name}</div>
          </div>
        );
      })}

      {/* People */}
      {people.map((person) => {
        return (
          <img
            key={person.nickname}
            src={IMAGE_MAP[person.image] || hobbitLora}
            alt={person.nickname}
            className="sprite"
            title={`${person.nickname}: ${person.mileage.toFixed(2)} Miles`}
            style={{
              left: `${leftPct(person.mileage)}%`,
              transform: 'translateX(-50%)',
            }}
          />
        );
      })}
    </div>
  );
}


export default function FellowshipTracker() {
  const [allSteps, setAllSteps] = useState([]);
  const [unseenEggs, setUnseenEggs] = useState([]);
  const [unseenPoops, setUnseenPoops] = useState([]);
  const [eggRevealDone, setEggRevealDone] = useState(false);
  const [loading, setLoading] = useState(true);

  const unseenEggBatches = useMemo(
    () => buildUnseenEggBatches(unseenEggs),
    [unseenEggs]
  );

  const onEggRevealComplete = useCallback(() => {
    setEggRevealDone(true);
  }, []);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const [stepsRes, eggsRes, poopsRes] = await Promise.all([
          fetch(`${URL}/allsteps`, { credentials: 'include' }),
          fetch(`${URL}/user_unseen_eggs`, { credentials: 'include' }),
          fetch(`${URL}/unseen_poops`, { credentials: 'include' }),
        ]);
        if (cancelled) return;
        if (stepsRes.status !== 200) throw new Error('Not logged in');
        const data = await stepsRes.json();
        setAllSteps(data);
        if (eggsRes.ok) {
          const eggs = await eggsRes.json();
          setUnseenEggs(Array.isArray(eggs) ? eggs : []);
        } else {
          setUnseenEggs([]);
        }
        if (poopsRes.ok) {
          const poops = await poopsRes.json();
          setUnseenPoops(Array.isArray(poops) ? poops : []);
        } else {
          setUnseenPoops([]);
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Navbar />
      {!loading && (
        <div className={"fellowship-body"}>
          <div className={"fellowship"}>
            <h1>one does not simply walk into mordor</h1>
            <Track people={allSteps} locations={ALL_LOCATIONS} />
          </div>
          {[...allSteps]
            .sort((a, b) => b.mileage - a.mileage) // highest mileage first
            .map((person) => (
              <MileageDisplay
                key={person.nickname}
                name={person.nickname}
                milesTraveled={person.mileage}
                imageUrl={IMAGE_MAP[person.image] || hobbitLora}
                message={person.shit_post}
                eggs={person.egg_count}
              />
            ))}
        </div>
      )}
      <FellowshipEggCorner
        eggableUsers={allSteps
          .filter((p) => p.eggable)
          .map((p) => ({ nickname: p.nickname, image: p.image }))}
      />
      {!loading && (
        <>
          <FellowshipUnseenEggReveal
            batches={unseenEggBatches}
            onAllComplete={onEggRevealComplete}
          />
          <FellowshipUnseenPoopReveal
            poopers={unseenPoops}
            active={eggRevealDone}
          />
        </>
      )}
    </>
  );
}
